import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";
import { POSTS } from "@/data/blogData";

export const TipsTeaser = () => {
  const posts = POSTS.slice(0, 3);
  return (
    <section id="tips" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12">
        <div>
          <div className="font-mono-accent text-xs tracking-widest uppercase text-[#2563EB] mb-3">/ Tips &amp; Advice</div>
          <h2 className="font-display font-black text-[#0A1A4A] text-4xl sm:text-6xl tracking-tight leading-[0.95]">
            STRAIGHT<br /><span className="text-[#2563EB]">TALKING TIPS</span>
          </h2>
        </div>
        <Link to="/tips" data-testid="tips-view-all" className="font-display font-extrabold uppercase text-sm tracking-wide px-6 py-3 border-2 border-[#0A1A4A] hover:bg-[#0A1A4A] hover:text-white transition-colors flex items-center gap-2">
          View all tips <ArrowUpRight size={16} />
        </Link>
      </div>
      <div className="grid sm:grid-cols-3 gap-6">
        {posts.map((p, i) => (
          <motion.div key={p.slug} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}>
            <Link to={`/tips/${p.slug}`} className="group block border-2 border-[#0A1A4A] overflow-hidden bg-white hover:shadow-hard transition-shadow h-full" data-testid={`teaser-post-${p.slug}`}>
              <div className="h-40 overflow-hidden border-b-2 border-[#0A1A4A] relative">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-3 left-3 bg-[#2563EB] text-white font-mono-accent text-[10px] tracking-widest uppercase px-2 py-1 border border-[#0A1A4A]">{p.category}</span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-1.5 font-mono-accent text-[10px] tracking-widest uppercase text-[#0A1A4A]/50 mb-3"><Clock size={12} /> {p.read} read</div>
                <h3 className="font-display font-extrabold uppercase text-lg text-[#0A1A4A] leading-tight">{p.title}</h3>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
